var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatmuteOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chatMute_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.191,
    height: 16.994,
    viewBox: "0 0 21.191 16.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15949",
    "data-name": "Group 15949",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15948",
    "data-name": "Group 15948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13891",
    "data-name": "Path 13891",
    d: "M12.447.147a1.487,1.487,0,0,0-1.594.205l-6.539,3.5H1.5A1.5,1.5,0,0,0,0,5.35v6.308a1.5,1.5,0,0,0,1.5,1.494H4.313l6.539,3.5A1.5,1.5,0,0,0,13.309,15.5V1.5A1.48,1.48,0,0,0,12.447.147ZM3.995,12.162H1.5a.5.5,0,0,1-.5-.5V5.35a.5.5,0,0,1,.5-.5H4v7.311Zm8.316,3.345a.5.5,0,0,1-.819.383l-6.5-3.469V4.587l6.5-3.469a.5.5,0,0,1,.819.383Z",
    transform: "translate(0 -0.003)",
    fill: "#26b963"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13904",
    "data-name": "Path 13904",
    d: "M3299.791,8816.067a4.363,4.363,0,0,1,1.472,2.733,5.856,5.856,0,0,1-1.472,3.09",
    transform: "translate(-3283.874 -8810.279)",
    fill: "none",
    stroke: "#26b963",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13905",
    "data-name": "Path 13905",
    d: "M3299.791,8816.067s2.341,2.032,2.341,4.349-2.341,4.915-2.341,4.915",
    transform: "translate(-3281.441 -8812)",
    fill: "none",
    stroke: "#26b963",
    strokeLinecap: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatmuteOff);
export default __webpack_public_path__ + "static/media/chatmute-off.4e32d570469ba56b67843fe9c27fd16f.svg";
export { ForwardRef as ReactComponent };